import moment, { Moment } from 'moment';

/**
 * 將後端可為空的日期轉成表單使用的日期值。
 *
 * @param {string | null | undefined} value 後端回傳的日期
 * @return {Moment | null} 空值回傳 null，其餘值保留 Moment 的有效或無效狀態供驗證處理
 */
export const parseOptionalMoment = (value: string | null | undefined): Moment | null => {
	if (value === null || value === undefined || value === '') {
		return null;
	}

	return moment(value);
};

/**
 * 判斷表單中的值是否為有效 Moment 日期。
 *
 * @param {unknown} value 待驗證的表單值
 * @return {boolean} 是否為有效日期
 */
export const isValidMoment = (value: unknown): value is Moment =>
	moment.isMoment(value) && value.isValid();
